import { Breadcrumb, Col, Row } from "antd";
import Title from "../UI/Title/Title";
import { WarehouseList } from "./WarehouseList";
import { useNavigate } from "react-router";
import { useMutation } from "react-query";
import { getWarehousesApi } from "../../api/warehouse";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import AddButton from "../UI/AddButton/addbutton";
import ResetButton from "../UI/ResetButton/resetbutton";
import { Search } from "../UI/Search/Search";
import { FilterInput } from "../UI/FilterApi/filterapi";

function Warehouse() {
  const navigate = useNavigate();
  const { t } = useTranslation("common");
  const [search, setSearch] = useState<string>("");
  const [filter, setFilter] = useState<boolean | undefined>(undefined);
  const [paginatedWarehouse, setPaginatedWarehouse] = useState<any>();
  const [page, setPage] = useState<number>(1);
  const [tableKey, setTableKey] = useState("");

  const resetFilters = () => {
    getWarehouses({
      limit: page * 10 + 10,
      q: "",
    }).then((res) => {
      setPaginatedWarehouse(res.data);
      setSearch("");
      setFilter(undefined);
      setTableKey((tableKey) => tableKey + 1);
    });
  };

  const handleSearch = () => {
    getWarehouses({
      limit: page * 10 + 10,
      q: search,
      isActive: filter,
    }).then((res: any) => {
      setPaginatedWarehouse(res.data);
    });
  };

  const handleFilter = (value: boolean | undefined) => {
    setFilter(value);
    const isActive = value === undefined ? undefined : value;
    getWarehouses({
      limit: page * 10 + 10,
      q: "",
      isActive: isActive,
    }).then((res: any) => {
      setPaginatedWarehouse(res.data);
    });
  };

  const getWarehouses = async (params: {
    limit: number;
    q: string;
    isActive?: boolean;
  }) => {
    // Make your API request here using the updated parameters
    return await WarehouseMutation(params);
  };

  const { mutateAsync: WarehouseMutation, isLoading: isWarehouseLoading } =
    useMutation("warehouses", getWarehousesApi);

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col offset={1} span={20}>
          <Breadcrumb
            items={[
              {
                title: <Link to="/main">{t("home")}</Link>,
              },
              {
                title: <>{t("inventory")}</>,
              },
              {
                title: (
                  <span className="breadcrumbcolor">
                    {" "}
                    {t("warehouse-list")}{" "}
                  </span>
                ),
              },
            ]}
          />
        </Col>
        <Col offset={1} span={22}>
          <Title title={`${t("warehouse-list")}`} />
        </Col>
        <Col offset={1} span={4}>
          <Search
            value={search}
            onKeyPress={(e: any) => e.code === "Enter" && handleSearch()}
            onChange={(e: any) => setSearch(e.target.value)}
            onEnter={() => {
              handleSearch();
            }}
          />
        </Col>
        <Col span={2}>
          <FilterInput
            key={tableKey}
            onChange={(value: boolean | undefined) => handleFilter(value)}
            value={filter}
          />
        </Col>
        <Col
          offset={14}
          span={2}
          style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
        >
          <Col>
            <ResetButton
              onClick={() => {
                resetFilters();
              }}
            />
          </Col>
          <AddButton onClick={() => navigate(`/warehouses/create`)} />
        </Col>
        <Col offset={1} span={22}>
          <WarehouseList
            WarehouseMutation={WarehouseMutation}
            isWarehouseLoading={isWarehouseLoading}
            search={search}
            paginatedWarehouse={paginatedWarehouse}
            setPaginatedWarehouse={setPaginatedWarehouse}
            page={page}
            setPage={setPage}
            filter={filter}
            tableKey={tableKey}
          />
        </Col>
      </Row>
    </>
  );
}

export default Warehouse;
